var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"548c16ee3e8ff01166ac7592baee27790fc11561"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app@coordinape"]={id:"548c16ee3e8ff01166ac7592baee27790fc11561"};
      